import request from '@/utils/service'

export function getLinks(data, locale) {
  return request({ url: 'friend-link/list', data, locale })
}

export function updateLink(data, locale) {
  return request({ url: 'friend-link', data, locale })
}

export function deleteLink(id, locale) {
  return request({ url: `friend-link/delete/${id}`, locale })
}
